import React, { FC } from 'react';
import { FormGroup, Input, Label } from 'reactstrap';
import { OrderItem } from '../../../../shared/orders';
import { useTranslation } from '../../../translations';
import { displayName, toggleElementInArray } from '../../../utils';
interface FulfillmentListProps {
  readonly items: OrderItem[];
  readonly selected: number[];
  readonly setSelected: (items: number[]) => void;
}

export const FulfillmentList: FC<FulfillmentListProps> = ({ items, selected, setSelected }) => {
  const { ts } = useTranslation();
  return (
    <div>
      {items.map((item) => {
        const name = `fulfillItem-${item.id}`;
        return (
          <FormGroup check className="mt-10" key={item.id}>
            <Input
              checked={selected.includes(item.id)}
              disabled={!!item.dispatchedOn}
              id={name}
              name={name}
              onChange={() => {
                setSelected(toggleElementInArray(selected, item.id));
              }}
              type="checkbox"
            />
            <Label check for={name}>
              {`x${item.quantity} - `}
              {displayName(item.product)}
              {item.dispatchedOn && <span>{ts('delivered')}</span>}
            </Label>
            <ul>
              {item.options
                .filter((t) => t.displayOnCashier)
                .map((option) => {
                  return (
                    <li key={option.optionId}>
                      {option.name}: {option.value}
                    </li>
                  );
                })}
            </ul>
          </FormGroup>
        );
      })}
    </div>
  );
};
